<template>
  <div id="main-message">
     
     <vs-row vs-justify="center">
        <vs-col type="flex" vs-justify="center" vs-align="center" vs-w="10">
            <vs-card>
            <div slot="header">
                <h3>
                Bienvenido a Mapgrafi
                </h3>
                    <p> Escriba su contraseña y confirme para restablecerla.</p>
                	<div class="vx-row">
			<div class="vx-col sm:w-1/4 w-full mb-2">
				<vs-input
					ref="password"
					type="password"
					data-vv-validate-on="blur"
					v-validate="'required|min:6|max:30'"
					name="contrasenia"
                    data-vv-as="contraseña"
					label-placeholder="Contraseña"
					placeholder="Contraseña*"
					v-model="contrasenia"
					class="w-full  mt-6" />
				<span class="text-danger text-sm">{{ errors.first('contrasenia') }}</span>
			</div>
			<div class="vx-col sm:w-1/4 w-full mb-2">
				<vs-input
					type="password"
					v-validate="'min:6|max:30|confirmed:password'"
					data-vv-validate-on="blur"
					data-vv-as="confirmación de contraseña"
					name="confirm_contraseniad"
					label-placeholder="Confirmar Contraseña"
					placeholder="Confirmar Contraseña*"
					v-model="confirm_contrasenia"
				class="w-full  mt-6" />
				<span class="text-danger text-sm">{{ errors.first('confirm_contrasenia') }}</span>
                <span class="text-danger text-sm" v-show="igualdad_contrasenia">  No son iguales las contraseñas.</span>
			</div>
            <div class="vx-col sm:w-1/4 w-full">
            	<vs-button class="float-right mt-6" @click="recoverUserConfirm()" :disabled="!validateForm">Aceptar</vs-button>
            </div>
		</div>
            </div>
            <div>
               
            </div>
            <div slot="footer">
                 <vs-row vs-justify="flex-end">
                        <router-link tag="div" to="/" style="float:left; margin-left: 5%;"> 
                            <vs-button color="primary" icon="home" ></vs-button>
                        </router-link>
                    <router-link tag="div" to="/account/login" style="float:left; margin-left: 5%;"> 
                        <vs-button color="primary" >Iniciar Sesión</vs-button>
                    </router-link>
                </vs-row>
            </div>
            </vs-card>
        </vs-col>
     </vs-row>
     <vs-popup class="holamundo" title="Mapgrafi informa" :active.sync="popupMensaje">
          <p>{{ mensaje }}
              <br>
          </p>
        <div class="flex flex-wrap justify-center mb-3">
              <vs-button  color="primary"  @click="cerrarModal()">Aceptar</vs-button>
          </div>
      </vs-popup>
  </div>
</template>

<script>

export default {
    data(){
        return {
            status              : null,
            confirm_contrasenia : '',
            contrasenia         : '',
            popupMensaje        : false,
            mensaje             : '',
            redireccinar        : false
        }
    },
    computed: {
        validateForm() {
            return !this.errors.any() && this.confirm_contrasenia != ''  && this.contrasenia != '' && (this.confirm_contrasenia === this.contrasenia) ;
        },
        igualdad_contrasenia(){
			var contrasenia = this.contrasenia;
			var confirm_contrasenia = this.confirm_contrasenia;
			if(contrasenia != '' && confirm_contrasenia != '' &&  contrasenia != ' ' && confirm_contrasenia != ' '){
				if(contrasenia !== confirm_contrasenia){
					return true 
				}else{
					return false
				}
			}
			return false;
		},
    },
    watch:{
        popupMensaje(){
            if(!this.popupMensaje){
                if(this.redireccinar)
                    this.$router.push({name:"accountForgot"})
            }
        }
    },
    methods: {
        clearForm(){
           this.confirm_contrasenia = '';
           this.contrasenia = '';
        },
        recoverUserConfirm(){
            if (!this.validateForm) return

            const payload = {
              userDetails: {
				contrasenia        : this.contrasenia,
				confirm_contrasenia: this.confirm_contrasenia,
				hash               : this.$route.params.hash,
              },
            }
		    this.$vs.loading();
			// PROCESO DE CREACION DE CUENTA 
            this.$store.dispatch('auth/recoverUserConfirmJWT', payload).then((response)=>{
                this.$vs.loading.close();
                this.clearForm();
                    this.mensaje = response.mensaje;
                    this.popupMensaje = true;
			})
	        .catch(error => { 
                this.clearForm();
                this.$vs.loading.close(); 
                this.mensaje = error;
                this.popupMensaje = true;
			})
			;
        },
        verificarHash(){
            this.redireccinar = false
            this.$vs.loading();
            const hash = this.$route.params.hash
            this.$store.dispatch('auth/verificarHash', { hash })
            .then( response => {
                this.$vs.loading.close()
                if(response.existeError){
                    this.popupMensaje   = true
                    this.redireccinar   = response.existeError 
                    this.mensaje        = response.mensaje
                }
            })
            .catch( error => {
                this.$vs.loading.close()
                this.mensaje        = error
                this.popupMensaje   = true
            })
        },
        cerrarModal(){
            this.popupMensaje = false
        },
    },
    created(){
        this.verificarHash()
    }
}
</script>

<style lang="scss" scoped>
#ecommerce-wishlist-demo {
    .item-view-primary-action-btn {
        color: #2c2c2c !important;
        background-color: #f6f6f6;
        min-width: 50%;
    }

    .item-view-secondary-action-btn {
        min-width: 50%;
    }
}
</style>
